// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"5cdab79a","964":"c74fe29d"}[chunkId] + ".chunk.css";
};